import React from "react";
import "./ExperienceCard.css";
import { resolveAsset } from "../data/assets";
import AddToCalendar from "./AddToCalendar";
import BookingMenu from "./BookingMenu";
import locations from "../data/locations.json";

export default function ExperienceCard({ data }) {
  const {
    partner,
    image,
    imageAlt,
    offer,
    date,
    location,
    cta,
    calendar,
    soldOut,
  } = data;

  const calendarEvent = calendar
    ? {
        ...calendar,
        location: calendar.location || location,
        description: calendar.description || offer,
      }
    : null;

  const ctaHref = cta && cta.href ? cta.href : "#";
  const ctaExternal = /^https?:/.test(ctaHref);

  const bookingOptions = data.bookingMenu
    ? locations
        .filter((l) => l.partner === partner)
        .map((l) => ({
          label: l.neighborhood,
          href: l.cta && l.cta.href ? l.cta.href : "#",
        }))
    : [];
  const useBookingMenu = data.bookingMenu && bookingOptions.length > 0;

  return (
    <article className="beef-card">
      <div className="beef-card__media">
        <img
          src={resolveAsset(image)}
          alt={imageAlt || ""}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="beef-card__body">
        <div className="beef-card__info">
          <h3 className="beef-card__title">{partner}</h3>
          <p className="beef-card__offer">{offer}</p>
          <div className="beef-card__meta">
            <p>{date}</p>
            <p className="beef-card__disclaimer">{location}</p>
          </div>
        </div>
        <div className="beef-card__actions">
          {soldOut ? (
            <span className="beef-btn beef-btn--soldout" aria-disabled="true">
              Sold Out
            </span>
          ) : useBookingMenu ? (
            <BookingMenu
              label={cta ? cta.label : "Book Now"}
              options={bookingOptions}
            />
          ) : (
            <a
              className="beef-btn"
              href={ctaHref}
              {...(ctaExternal
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              {cta ? cta.label : "Learn More"}
            </a>
          )}
          {soldOut ? null : (
            <AddToCalendar event={calendarEvent} id={data.id} />
          )}
        </div>
      </div>
    </article>
  );
}
